import { gql } from "@apollo/client";

export const UPDATE_VEHICLE = gql`
    mutation UpdateVehicle($input: UpdateVehicleInput) {
        updateVehicle(input: $input)
    }
`;

export const CREATE_VEHICLE = gql`
    mutation CreateVehicle($input: CreateVehicleInput) {
        createVehicle(input: $input)
    }
`;